// assistia-sdk/src/client.ts
const API_URL = (typeof process !== 'undefined' && process.env)
    ? process.env['ASSISTIA_API_URL'] ?? 'http://localhost:8000'
    : 'http://localhost:8000';
/** Helper to handle HTTP responses and return a structured SecurityResponse */
import { SecurityErrorType } from "./types/security.js";
export async function handleResponse(response) {
    const base = {
        blocked: false,
        status: response.status,
    };
    if (response.ok) {
        if (response.status === 204) {
            return { ...base, data: undefined };
        }
        const data = await response.json();
        return { ...base, data };
    }
    // Non‑OK responses – map to SecurityResponse
    const errBody = await response.json().catch(() => ({ message: response.statusText }));
    const parsed = errBody;
    const message = parsed.message || parsed.detail || "Unexpected error";
    let errType = SecurityErrorType.UNKNOWN;
    if (response.status === 403) {
        // 6.8-01 : { blocked: true } = guardrail (contenu) ; sinon auth/licence.
        errType = parsed.blocked === true
            ? SecurityErrorType.BLOCKED
            : SecurityErrorType.FORBIDDEN;
    }
    else if (response.status === 400) {
        errType = SecurityErrorType.INVALID_PAYLOAD;
    }
    return {
        blocked: true,
        status: response.status,
        error: { type: errType, message },
    };
}
function authHeaders(token) {
    return token ? { Authorization: `Bearer ${token}` } : {};
}
export async function activateLicense(payload, token) {
    const resp = await fetch(`${API_URL}/api/v1/admin/licenses`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders(token) },
        body: JSON.stringify(payload),
    });
    return handleResponse(resp);
}
export async function getStatus(licenseKeyHash, token) {
    const resp = await fetch(`${API_URL}/api/v1/admin/licenses/${licenseKeyHash}`, {
        method: 'GET',
        headers: { Accept: 'application/json', ...authHeaders(token) },
    });
    return handleResponse(resp);
}
export async function revokeLicense(licenseKeyHash, token) {
    const resp = await fetch(`${API_URL}/api/v1/admin/licenses/${licenseKeyHash}`, {
        method: 'DELETE',
        headers: { ...authHeaders(token) },
    });
    return handleResponse(resp);
}
//# sourceMappingURL=client.js.map